<template lang="pug">
  section.Chapter(title="")
    ChapterTitle(
      :title="item.title"
    )
    .Chapter_content
      ParagraphList(:items="item.paragraphs")
</template>

<script>

import ParagraphList from '@/components/ParagraphList'
import ChapterTitle from '@/components/ChapterTitle'

export default {
  props: ['item'],
  components: {
    ChapterTitle,
    ParagraphList
  },
  mounted () {
    this.$emit('mounted', this)
  },
  beforeDestroy () {
    this.$emit('beforeDestroy', this)
  }
}

</script>

<style lang="stylus">
.Chapter
  &_content
    background-color $beige-l
</style>
